export const ExternalLinksEnum = {
    eBiz :  {
        English  : [
            {
               label : "Business Customer Details Agreement",
               link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Customer%20Details%20Agreement%20%28Customer%20Copy%29%20ENG_no%20signature.pdf",
               code : "BCDA"
            },
            {
                label : "Business Account Details Agreement",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Account%20Details%20Agreement%20%28Customer%20Copy%29.pdf",
                code : "BADA"
             },
             {
                label : "Business Debit Cardmembers Agreement and Product Disclosure Sheet",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/transactions/business-debit-card/BDC-PDS-Agreement.pdf",
                code : "BDCA"
             },
             {
                label : "Terms & Conditions Governing Transaction Banking",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/terms-and-conditions/Transaction%20Banking%20Services%20TnC%20%28Eng%29.pdf",
                code : "TCGT"
             },
             {
                label : "eKYC Verification Portal Terms & Conditions",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/eKYC-Terms-and-Conditions.pdf",
                code : "EVPT"
             },
             {
                label : "OCBC eBiz Account Product Disclosure Sheet",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/eBiz_Product_Information_Sheet_(final)_GTB_15022021.pdf",
                code : "APDS"
             },
             {
                label : "Accounts and Services Terms and Conditions",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/personal/pdf/help-and-support/general/OBMB_Accounts_and_Services_Main_Terms_and_Conditions_ENG.pdf",
                code : "ASTC"
             }
        ],
        Malay  : [
            {
               label : "Perjanjian Maklumat Pelanggan Perniagaan",
               link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Customer%20Details%20Agreement%20%28Customer%20Copy%29%20BM_no%20signature.pdf",
               code : "BCDA"
            },
            {
                label : "Perjanjian Maklumat Akaun Perniagaan",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Account%20Details%20Agreement%20%28Customer%20Copy%29_BM.pdf",
                code : "BADA"
             },
             {
                label : "Perjanjian Ahli Kad Debit Perniagaan dan Lembaran Pendedahan Produk",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/transactions/business-debit-card/BDC-PDS-Perjanjian.pdf",
                code : "BDCA"
             },
             {
                label : "Terma dan Syarat Perkhidmatan Transaksi Perbankan",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/terms-and-conditions/Transaction%20Banking%20Services%20TnC%20%28BM%29.pdf",
                code : "TCGT"
             },
             {
                label : "Terma dan Syarat Portal Pengesahan eKYC",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/BM_eKYC_TermsNConditions.pdf ",
                code : "EVPT"
             },
             {
                label : "Lembaran Pendedahan Produk Akaun OCBC eBiz",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/eBiz_Account_Product_Information_Sheet_BM.pdf",
                code : "APDS"
             },
             {
                label : "Terma dan Syarat Akaun dan Perkhidmatan",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/personal/pdf/help-and-support/general/OBMB_Accounts_and_Services_Main_Terms_and_Conditions_BM.pdf",
                code : "ASTC"
             }
        ]
    },
    
    eBizi : {
        
        English  : [
            {
                label : "Business Customer Details Agreement",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Customer%20Details%20Agreement%20%28Customer%20Copy%29%20ENG_no%20signature.pdf",
                code : "BCDA"
            },
            {
                label : "Business Account Details Agreement",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Account%20Details%20Agreement%20%28Customer%20Copy%29.pdf",
                code : "BADA"
            },
            {
                label : "Business Debit Cardmembers Agreement and Product Disclosure Sheet",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/transactions/business-debit-card-i/BDC-i-PDS-Agreement-EN.pdf",
                code : "BDCA"
            },
            {
                label : "Terms & Conditions Governing Transaction Banking",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/terms-and-conditions/Transaction%20Banking%20Services%20TnC%20%28Eng%29.pdf",
                code : "TCGT"
            },
            {
                label : "eKYC Verification Portal Terms & Conditions",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/eKYC-Terms-and-Conditions.pdf",
                code : "EVPT"
            },
            {
                label : "OCBC eBiz Account-i Product Disclosure Sheet",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/eBiz_Account-i_Product_Information_Sheet_EN.pdf",
                code : "APDS"
            },
            // {
            //     label : "OCBC Al-Amin Bank Berhad Terms & Condition",
            //     link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/personal/pdf/help-and-support/general/OABB_Accounts_and_Services_Main_Terms_and_Conditions_ENG.pdf",
            //     code : "BBTC"
            // },
            {
                label : "Accounts and Services Terms and Conditions",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/personal/pdf/help-and-support/general/OABB_Accounts_and_Services_Main_Terms_and_Conditions_ENG.pdf",
                code : "ASTC"
             }
        ],
        Malay  : [
            {
                label : "Perjanjian Maklumat Pelanggan Perniagaan",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Customer%20Details%20Agreement%20%28Customer%20Copy%29%20BM_no%20signature.pdf",
                code : "BCDA"
            },
            {
                label : "Perjanjian Maklumat Akaun Perniagaan",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Account%20Details%20Agreement%20%28Customer%20Copy%29_BM.pdf",
                code : "BADA"
            },
            {
                label : "Perjanjian Ahli Kad Debit-i Perniagaan dan Lembaran Pendedahan Produk",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/transactions/business-debit-card-i/BDC-i-PDS-Agreement-BM.pdf",
                code : "BDCA"
            },
            {
                label : "Terma dan Syarat Perkhidmatan Transaksi Perbankan", 
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/terms-and-conditions/Transaction%20Banking%20Services%20TnC%20%28BM%29.pdf",
                code : "TCGT"
            },
            {
                label : "Terma dan Syarat Portal Pengesahan eKYC",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/BM_eKYC_TermsNConditions.pdf",
                code : "EVPT"
            },
            {
                label : "Lembaran Pendedahan Produk Akaun OCBC eBiz-i",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/eBiz_Account-i_Product_Information_Sheet_BM.pdf",
                code : "APDS"
            },
            // {
            //     label : "Terma dan Syarat OCBC Al-Amin Bank Berhad",
            //     link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/personal/pdf/help-and-support/general/OABB_Accounts_and_Services_Main_Terms_and_Conditions_BM.pdf",
            //     code : "BBTC"
            // },
            {
                label : "Terma dan Syarat Akaun-i dan Perkhidmatan",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/personal/pdf/help-and-support/general/OABB_Accounts_and_Services_Main_Terms_and_Conditions_BM.pdf",
                code : "ASTC"
             }
        ]
        
    },
    BusinessAccess :  {
        English  : [
            {
               label : "Business Customer Details Agreement",
               link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Customer%20Details%20Agreement%20%28Customer%20Copy%29%20ENG_no%20signature.pdf",
               code : "BCDA"
            },
            {
                label : "Business Account Details Agreement",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Account%20Details%20Agreement%20%28Customer%20Copy%29.pdf",
                code : "BADA"
             },
             {
                label : "Business Debit Cardmembers Agreement and Product Disclosure Sheet",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/transactions/business-debit-card/BDC-Cardholders_Agreement_PDS.pdf",
                code : "BDCA"
             },
             {
                label : "Terms & Conditions Governing Transaction Banking",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/terms-and-conditions/Transaction%20Banking%20Services%20TnC%20%28Eng%29.pdf",
                code : "TCGT"
             },
             {
                label : "eKYC Verification Portal Terms & Conditions",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/eKYC-Terms-and-Conditions.pdf",
                code : "EVPT"
             },
             {
                label : "OCBC Bank Business Access Terms and Conditions",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/terms-and-conditions/OBMB%20BA_Eng.pdf",
                code : "APDS"
             },
             {
                label : "Accounts and Services Terms and Conditions",
                link : "https://www.ocbc.com.my/assets/pdf/Help_and_support/OBMB_Accounts_and_Services_Main_Terms_and_Conditions_ENG.pdf",
                code : "ASTC"
             }
        ]
    },
    BusinessSignature :  {
        English  : [
            {
               label : "Business Customer Details Agreement",
               link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Customer%20Details%20Agreement%20%28Customer%20Copy%29%20ENG_no%20signature.pdf",
               code : "BCDA"
            },
            {
                label : "Business Account Details Agreement",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/velocity/Business%20Account%20Details%20Agreement%20%28Customer%20Copy%29.pdf",
                code : "BADA"
             },
             {
                label : "Business Debit Cardmembers Agreement and Product Disclosure Sheet",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/transactions/business-debit-card/BDC-Cardholders_Agreement_PDS.pdf",
                code : "BDCA"
             },
             {
                label : "Terms & Conditions Governing Transaction Banking",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/terms-and-conditions/Transaction%20Banking%20Services%20TnC%20%28Eng%29.pdf",
                code : "TCGT"
             },
             {
                label : "eKYC Verification Portal Terms & Conditions",
                link : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/eKYC-Terms-and-Conditions.pdf",
                code : "EVPT"
             },
             {
                label : "OCBC Bank Business Signature Terms and Conditions",
                link : "https://www.ocbc.com.my/assets/pdf/MY/Accounts_and_Services/terms-and-conditions/OBMB%20BS_Eng.pdf",
                code : "APDS"
             },
             {
                label : "Accounts and Services Terms and Conditions",
                link : "https://www.ocbc.com.my/assets/pdf/Help_and_support/OBMB_Accounts_and_Services_Main_Terms_and_Conditions_ENG.pdf",
                code : "ASTC"
             }
        ]
    },
    EkycFaq : {
        eBizi : {
            ms: "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/BM_eKYC_Application_eBiz-i_FAQ.pdf",
            "en-us" : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/EN_eKYC_Application_eBiz-i_FAQ.pdf"
        },
        eBiz : {
            ms: "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/BM_eKYC_Application_FAQ.pdf",
            "en-us" : "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/EN_eKYC_Application_FAQ.pdf"
        }
    }
}
